import React from 'react';

const BetBlock = ({label1, label2, label3, label4, amount1, amount2, amount3, amount4}) => {
    return (
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', padding: 20}}>
            <div style={{width: '100%', display: 'flex', marginBottom: 12}}>
                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', width: '50%'}}>
                    <span style={{
                        color: 'hsla(0,0%,100%,.5)',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {label1}
                    </span>
                    <span style={{
                        color: '#fff',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {amount1}
                    </span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', width: '50%'}}>
                    <span style={{
                        color: 'hsla(0,0%,100%,.5)',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {label2}
                    </span>
                    <span style={{
                        color: '#fff',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {amount2}
                    </span>
                </div>
            </div>
            <div style={{width: '100%', display: 'flex'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', width: '50%'}}>
                    <span style={{
                        color: 'hsla(0,0%,100%,.5)',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {label3}
                    </span>
                    <span style={{
                        color: '#fff',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {amount3}
                    </span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', width: '50%'}}>
                    <span style={{
                        color: 'hsla(0,0%,100%,.5)',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {label4}
                    </span>
                    <span style={{
                        color: '#fff',
                        fontSize: 16,
                        textAlign: 'right',
                        fontFamily: 'PT-sans, sans-serif',
                        marginRight: 12,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {amount4}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default BetBlock;